module.exports = __webpack_public_path__ + "static/img/4_2.5f1a61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/4_2.png
// module id = 14ja
// module chunks = 1